import styled from '@emotion/styled';
import { ListItemButton } from '@mui/material';
import { Colors } from 'styles/variables/colors';

type BurgerMenuProps = {
    isActive: boolean;
};

export const BurgerMenu = styled.button<BurgerMenuProps>`
    fill: ${Colors.darkGray};
`;

export const DropDownMenu = styled.ul`
    border-radius: 4px;
    padding: 10px;
    gap: 5px;
    border: 1px solid ${Colors.tableBorder};
    box-shadow:
        0px 1px 2px rgba(0, 0, 0, 0.3),
        0px 1px 3px 1px rgba(0, 0, 0, 0.15);
`;

type Props = {
    margin?: string;
    marginRight?: string;
};

export const MenuItem = styled(ListItemButton)<Props>`
    padding: 0;
`;

export const Item = styled.div<Props>`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    flex-wrap: nowrap;
    height: 40px;
    border-radius: 2px;
    padding: 10px;
    margin-left: ${(props) => (props.margin ? props.margin : '')};
    width: 100%;
`;

type SVGProps = {
    fill?: string;
    marginRight?: string;
};

export const SvgContainer = styled.div<SVGProps>`
    display: flex;
    justify-content: center;
    align-items: center;
    min-width: 20px;
    margin-right: ${(props) => (props.marginRight ? props.marginRight : '13px')};

    & svg {
        fill: ${(props) => (props.fill ? `${props.fill}` : `${Colors.darkGray}`)};
    }
`;

export const Text = styled.span`
    font-family: 'Montserrat', sans-serif;
    font-weight: 500;
    font-size: 14px;
    color: ${Colors.darkGray};
`;
